import { isLegacyOpenTicketDbStatus } from "./ticketStatus";
import type { TicketStatus } from "./tickets";

export const supportTicketEditBypassRoleNames = ["support.admin", "crm.admin"] as const;

export function isTicketOpenForEdit(status: string): boolean {
  return isLegacyOpenTicketDbStatus(status);
}

export function canEditSupportTicket(status: TicketStatus | string, hasBypassRole: boolean): boolean {
  return hasBypassRole || isTicketOpenForEdit(status);
}

export function hasSupportTicketEditBypassRole(roles: readonly string[] | undefined): boolean {
  return supportTicketEditBypassRoleNames.some((role) => roles?.includes(role) ?? false);
}
